"use strict";

require("core-js/modules/es.array.sort.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Label = _interopRequireDefault(require("../Label"));

var _ImageCarousel = _interopRequireDefault(require("./ImageCarousel.proptypes"));

var _SliderTrack = _interopRequireDefault(require("./components/SliderTrack"));

var _CardWrapper = _interopRequireDefault(require("./components/CardWrapper"));

var _RightArrow = _interopRequireDefault(require("./components/RightArrow"));

var _LeftArrow = _interopRequireDefault(require("./components/LeftArrow"));

var _SliderWrapper = _interopRequireDefault(require("./components/SliderWrapper"));

var _SliderList = _interopRequireDefault(require("./components/SliderList"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var Container = _styledComponents.default.div.withConfig({
  displayName: "ImageCarousel__Container",
  componentId: "sc-1rj3uh3-0"
})(["height:", ";width:100%;"], function (props) {
  return props.height || 'inherit';
});

var Tile = _styledComponents.default.div.withConfig({
  displayName: "ImageCarousel__Tile",
  componentId: "sc-1rj3uh3-1"
})(["position:absolute;top:11px;left:12px;display:flex;justify-content:center;align-items:center;box-sizing:border-box;"]);

var ImageCarousel = function ImageCarousel(props) {
  var theme = props.theme,
      accessible = props.accessible,
      LeftArrow = props.LeftArrow,
      RightArrow = props.RightArrow,
      Dot = props.Dot,
      showArrows = props.showArrows,
      showDots = props.showDots,
      children = props.children,
      cardsToShowProp = props.cardsToShow,
      afterSlide = props.afterSlide,
      beforeSlide = props.beforeSlide,
      infinite = props.infinite,
      responsive = props.responsive,
      padding = props.padding,
      margin = props.margin,
      hideArrowsOnNoSlides = props.hideArrowsOnNoSlides,
      DotsWrapper = props.DotsWrapper,
      ImageIndicator = props.ImageIndicator,
      ImageIndicatorWrapper = props.ImageIndicatorWrapper,
      expandCarouselArrowClickableArea = props.expandCarouselArrowClickableArea,
      showImageIndicator = props.showImageIndicator,
      flyerDiscountText = props.flyerDiscountText;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      initialCard = _useState2[0],
      setInitialCard = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      childWidth = _useState4[0],
      setChildWidth = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      cardsToShow = _useState6[0],
      setCardsToShow = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      hideArrows = _useState8[0],
      setHideArrows = _useState8[1];

  var _useState9 = (0, _react.useState)(true),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      firstRender = _useState10[0],
      setFirstRender = _useState10[1];

  var changeInitialCard = function changeInitialCard(initialCardToSet) {
    if (beforeSlide) {
      beforeSlide();
    }

    setInitialCard(initialCardToSet);
    setFirstRender(false);
  };

  var updateResponsiveView = (0, _react.useCallback)(function () {
    var numberOfChildren = children ? children.length || 1 : 0;

    if (responsive) {
      var resp = responsive.map(function (obj) {
        return _objectSpread({}, obj);
      }).sort(function (key) {
        return function (a, b) {
          return (// eslint-disable-next-line no-nested-ternary
            a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0
          );
        };
      }('breakPoint')); // eslint-disable-line

      var updatedCardsToShow = cardsToShow;
      resp.forEach(function (_ref) {
        var breakPoint = _ref.breakPoint,
            card = _ref.cardsToShow;

        if (breakPoint <= window.innerWidth) {
          updatedCardsToShow = card;
        }
      });
      var updatedInitialCard = numberOfChildren - updatedCardsToShow < initialCard ? numberOfChildren - updatedCardsToShow : initialCard;
      setCardsToShow(updatedCardsToShow);
      setChildWidth(100 / updatedCardsToShow);
      setInitialCard(updatedInitialCard);
      setHideArrows(hideArrowsOnNoSlides && numberOfChildren <= updatedCardsToShow);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [cardsToShow, childWidth, hideArrows]);
  (0, _react.useEffect)(function () {
    var numberOfChildren = children ? children.length || 1 : 0;
    var cardsToShowCount = cardsToShowProp || numberOfChildren;
    var childWidthValue = 100 / cardsToShowCount;
    setChildWidth(childWidthValue);
    setCardsToShow(cardsToShowCount);
    setHideArrows(hideArrowsOnNoSlides && numberOfChildren <= cardsToShowCount);
    updateResponsiveView();

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', updateResponsiveView);
    }

    return function () {
      if (typeof window !== 'undefined') window.removeEventListener('resize', updateResponsiveView);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    if (afterSlide) {
      afterSlide();
    }
  }, [afterSlide]);

  var handleLeftArrowClick = function handleLeftArrowClick(evt) {
    var childrenCount = children ? children.length : 0;

    if (evt && evt.preventDefault) {
      evt.preventDefault();
    }

    var nextInitialCard = initialCard - 1;

    if (nextInitialCard < 0) {
      nextInitialCard = childrenCount - cardsToShow;
    }

    changeInitialCard(nextInitialCard);
  };

  var handleRightArrowClick = function handleRightArrowClick(evt) {
    var childrenCount = children ? children.length : 0;

    if (evt && evt.preventDefault) {
      evt.preventDefault();
    }

    var nextInitialCard = initialCard + 1;

    if (childrenCount - cardsToShow < nextInitialCard) {
      nextInitialCard = 0;
    }

    changeInitialCard(nextInitialCard);
  };

  var renderLeftArrow = function renderLeftArrow() {
    var LeftArrowToRender = LeftArrow || _LeftArrow.default;
    return LeftArrowToRender({
      onClick: handleLeftArrowClick,
      disabled: !infinite && !initialCard,
      theme: theme,
      expandCarouselArrowClickableArea: expandCarouselArrowClickableArea
    });
  };

  var renderRightArrow = function renderRightArrow() {
    var numberOfChildren = children ? children.length || 1 : 0;
    var RightArrowToRender = RightArrow || _RightArrow.default;
    return RightArrowToRender({
      onClick: handleRightArrowClick,
      disabled: !infinite && initialCard + cardsToShow === numberOfChildren,
      theme: theme,
      expandCarouselArrowClickableArea: expandCarouselArrowClickableArea
    });
  };

  var renderChildren = function renderChildren(childrenNode) {
    var displayCards = [];

    _react.default.Children.forEach(childrenNode, function (child, index) {
      if (firstRender) {
        if (index === initialCard) {
          displayCards.push( /*#__PURE__*/_react.default.createElement(_CardWrapper.default, {
            width: childWidth
          }, child));
        }
      } else {
        displayCards.push( /*#__PURE__*/_react.default.createElement(_CardWrapper.default, {
          width: childWidth
        }, child));
      }
    });

    return displayCards;
  };

  var renderDots = function renderDots() {
    var dots = [];
    var numberOfChildren = children ? children.length || 1 : 0;
    var i;

    var _loop = function _loop() {
      var index = i;
      dots.push( /*#__PURE__*/_react.default.cloneElement(Dot, {
        active: index === initialCard,
        key: index,
        onClick: function onClick() {
          return changeInitialCard(index);
        }
      }));
    };

    for (i = 0; i <= numberOfChildren - cardsToShow; i += 1) {
      _loop();
    }

    return dots;
  };

  var renderImageIndicator = function renderImageIndicator() {
    var dots = [];
    var numberOfChildren = children ? children.length || 1 : 0;
    var i;

    var _loop2 = function _loop2() {
      var index = i;
      dots.push( /*#__PURE__*/_react.default.cloneElement(ImageIndicator, {
        active: index === initialCard,
        key: index,
        onClick: function onClick() {
          return changeInitialCard(index);
        },
        theme: theme
      }));
    };

    for (i = 0; i <= numberOfChildren - cardsToShow; i += 1) {
      _loop2();
    }

    return dots;
  };

  (0, _react.useEffect)(function () {
    changeInitialCard(0);
  }, [children]);

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(Container, {
      id: "image-carousel-basic",
      height: "100%",
      tabIndex: tabIndex
    }, /*#__PURE__*/_react.default.createElement(_SliderWrapper.default, {
      padding: padding,
      margin: margin
    }, showArrows && !hideArrows && renderLeftArrow(), /*#__PURE__*/_react.default.createElement(_SliderTrack.default, null, /*#__PURE__*/_react.default.createElement(_SliderList.default, {
      translateX: initialCard * childWidth
    }, renderChildren(children, cardsToShow || children.length))), showArrows && !hideArrows && renderRightArrow(), flyerDiscountText && /*#__PURE__*/_react.default.createElement(Tile, null, /*#__PURE__*/_react.default.createElement(_Label.default, {
      labelColor: "primaryLight",
      textColor: "primaryDark",
      theme: theme
    }, flyerDiscountText)), /*#__PURE__*/_react.default.createElement(ImageIndicatorWrapper, null, showImageIndicator && renderImageIndicator(theme))), /*#__PURE__*/_react.default.createElement(DotsWrapper, null, showDots && renderDots()));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain(theme));
};

ImageCarousel.propTypes = _ImageCarousel.default.PropTypes;
ImageCarousel.defaultProps = _ImageCarousel.default.DefaultProps;
var _default = ImageCarousel;
exports.default = _default;